export default "__VITE_ASSET__IHP9rAr2H5J2loOiF4uFhw__"